<template>
  <div>
    <top-bar :user="this.user" />
    <MenuItems :user="this.user" :menuSelected="{ manageOffers: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ manageOffers: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <person-details v-if="this.selectedPerson" :person="this.selectedPerson" :user="this.user" />
        <div v-else>
          <div v-if="isUserAdmin(user)" class="account-title ">
            <h1>{{ $t("managementOffersTitle") }}</h1>
            <p>{{ $t("managementOffersShortDesc") }}</p>
            <br />
          </div>
          <!-- userul este marketing -->
          <div v-else class="account-title ">
            <h1>{{ $t("managementOffersMarketingTitle") }}</h1>
            <br />
          </div>
          <div v-if="isUserAdmin(user)" class=" d-flex ">
            <!-- <div  class="left"> -->
            <img class="border-round square-50" v-for="(entry, index) in usersForManageCompany" :key="index"
              :src="getImagePath() + 'users/user_' + entry.person.id + '.png'"
              @error="($event.target.src = require('@/assets/images/offer_0.svg'))" @click="selectPerson(entry)" />
            <!-- </div> -->

          </div>
          <div v-if="isUserAdmin(user) && this.filter.person" class=" d-flex align-items-center justify-content-between ">

            <div class="person-offer-info ">
              <img :src="
                this.getImagePath() +
                'users/user_' +
                this.filter.person.id +
                '.png'
              " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" w />
            </div>
            <div class="text">
              <p>{{ $t("transferFromPersonLabel") }}
              </p>
              <!-- <p class="p-small" v-html="
                    $t('')
                  "></p> -->
              <p class="color-orange">
                {{
                  this.filter.person.first_name +
                  " " +
                  this.filter.person.last_name
                }}

              </p>
            </div>
            <p>{{ $t("transferToPersonLabel") }}</p>

            <div class="person-offer-info ">
              <img :src="
                this.getImagePath() +
                'users/user_' +
                this.personForTransfer.id +
                '.png'
              " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
            </div>
            <div class="text">
              <p class="color-orange">
                {{
                  this.personForTransfer.first_name ?
                  this.personForTransfer.first_name +
                  " " +
                  this.personForTransfer.last_name :
                  this.personForTransfer.email
                }}

              </p>
            </div>

            <!-- <div class="person-offer-info ">
            <img :src="this.getImagePath() + 'users/user_' + this.filter.person_id + '.png'"
              @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
          </div> -->

            <multiselect v-model="personForTransfer" :options="usersForTransfer" select-label="" selected-label=""
              deselect-label="" openDirection="bottom" track-by="first_name" :custom-label="customLabel"
              :loading="isLoading">
            </multiselect>
          </div>
          <div class=" d-flex justify-content-between align-items-center margin-y-10">
            <div class="left">
              {{ $t("addOfferChooseType") }}
              <a v-for="(entry, index) in this.offerTypes" :key="index" class="choose-type"
                :class="filter.type === entry && 'active'" @click="selectFilterType(entry)">{{ $t("chooseType_" + entry)
                }}</a>
            </div>
            <div class="right">
              <div class="flex-center" style="justify-content: flex-end">
                <div>
                  <small>{{ $t("sortFilter") }}</small>
                  <select class="" @change="sortByChanged">
                    <option v-for="(entry, index) in sortBy" :key="index" :value="entry">
                      {{ $t("sortBy_" + entry) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div>
              <div v-if="
                this.dedicatedOffers === null || this.dedicatedOffers === undefined
              ">
                <div class="loading">
                  <!-- <img src="@/assets/images/loading.gif" /> -->
                </div>
              </div>
              <div v-else v-for="(offer, index) in dedicatedOffers" :key="index" class="content-delivery">
                <div class="offer_header">
                  <div class="left">
                    <b-form-checkbox @change="offerChecked(offer)" v-if="isUserAdmin(user)"
                      :checked="isOfferChecked(offer) >= 0"></b-form-checkbox>
                    <div class="d-flex flex-wrap flex-xl-nowrap justify-content-center align-items-center text-12-bold">
                      <img class="square-32 border-round" :src="
                        getImagePath() +
                        'users/user_' +
                        offer.person.id +
                        '.png'
                      " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
                      <p class="m-0">{{ $t("addedByLabel") }}</p>
                      <a class="user-added" @click="seeUserProfile(offer.person)">{{
                        " " + offer.person.first_name +
                        " " +
                        offer.person.last_name
                      }}</a>

                    </div>
                    <img src="@/assets/images/calendar.svg" class="mx-2" />
                    <small>Data:
                      <!-- {{offer.start_date}} -->
                      {{ formatDate(offer.creation_date, "DD/MM/YYYY", "YYYY-MM-DDThh:mm:ss") }}</small>
                    <small class="bold" :class="'status_' + offer.status_id">{{
                      ' ' + $t('offerStatus_' + offer.status_id)
                    }}</small>
                  </div>
                  <div v-if="isUserMarketing(user) && offer.status_id === 10" class="right">
                    <div class="flex-center" style="justify-content: flex-end">
                      <a class="button-all button-orange" @click="approveOffer(offer)">{{
                        $t("approveOfferButtonLabel")
                      }}</a>
                      <a class="button-all button-red" @click="switchModifyOrDeleteModalPopup('REJECT', offer)">{{
                        $t("rejectOfferButtonLabel")
                      }}</a>
                    </div>
                  </div>
                  <div v-else-if="!isUserMarketing(user)" class="right">
                    <div class="flex-center" style="justify-content: flex-end">
                      <a class="button-all button-orange" @click="editOffer(offer)">{{
                        $t("editOfferButtonLabel")
                      }}</a>
                      <a class="button-all button-red" @click="switchModifyOrDeleteModalPopup('DELETE', offer)">{{
                        $t("deleteOfferButtonLabel")
                      }}</a>
                    </div>
                  </div>
                </div>
                <br clear="all" />
                <div class="offer_details">
                  <div class="imageDiv">
                    <img class="image" :src="getImagePath() + 'offers/offer_' + offer.id + '.png'"
                      @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
                  </div>
                  <!-- <div class="image"
                  :style="{ 'background-image': `url(${getImagePath() + 'offers/offer_' + offer.id + '.png'})` }"></div> -->
                  <b-container fluid class="border-box">
                    <!-- <b-row>
                    <b-col class="border-box">
                      <p>
                        <small class="bold">{{ $t("statusNameLabel") }}</small>

                        <small>{{ $t('offerStatus_' + offer.status_id) }}</small>
                      </p>
                    </b-col>
                    <b-col class="border-box">
                      <p v-if="offer.reject_reason.length > 0">
                        <small class="bold">{{ $t("rejectReasonLabel") }}</small>

                        <small class="bold">{{ offer.reject_reason }}</small>
                      </p>
                    </b-col>
                  </b-row> -->
                    <b-row>
                      <b-col class="border-box">
                        <p>
                          <small class="bold">{{ $t("productShortNameLabel") }}</small>
                          <br />
                          <small>{{ offer.name }}</small>
                        </p>
                      </b-col>
                      <b-col class="border-box">
                        <p>
                          <small class="bold">{{ $t("firstPriceNameLabel") }}</small>
                          <br />
                          <small>{{ offer.price + " " + offer.currency }}</small>
                        </p>
                      </b-col>
                      <!-- <b-col class="border-box">
                      <p>
                        <small class="bold">{{ $t("discoutTypeLabel") }}</small>
                        <br />
                        <small>{{ $t('discountLabel' + (offer.discount === '' ? 'Deduction' : 'Discount')) }}</small>
                      </p>
                    </b-col> -->
                      <b-col class="border-box">
                        <p>
                          <small class="bold">{{ $t("discountValueLabel") }}</small>
                          <br />
                          <small>{{
                            offer.discount === 0 ? (offer.deduction + " " + offer.currency) : (offer.discount + "% ")}}</small>
                        </p>
                      </b-col>
                      <b-col v-if="offer.type === 'OFFER'" class="border-box">
                        <p>
                          <small class="bold">{{ $t("measureUnitLabel") }}</small>
                          <br />
                          <small>{{ offer.measure_unit }}</small>
                        </p>
                      </b-col>
                      <b-col v-else class="border-box">
                        <p>
                          <small class="bold">{{ $t("locationValueLabel") }}</small>
                          <br />
                          <small>{{ offer.location }}</small>
                        </p>
                      </b-col>
                      <b-col class="border-box">
                        <p>
                          <small class="bold">{{ $t("validityStartLabel") }}</small>
                          <br />
                          <small>{{
                            formatDate(offer.validity_start_date, "DD/MM/YYYY", "YYYY-MM-DDThh:mm:ss")
                          }}</small>
                        </p>
                      </b-col>
                      <b-col class="border-box">
                        <p>
                          <small class="bold">{{ $t("validityEndLabel") }}</small>
                          <br />
                          <small>{{ formatDate(offer.validity_end_date, "DD/MM/YYYY", "YYYY-MM-DDThh:mm:ss") }}</small>
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <!-- <b-col>
                      <p>
                        <small class="bold">{{ $t("currencyLabel") }}</small>
                        <br />
                        <small>{{ offer.currency }}</small>
                      </p>
                    </b-col> -->
                      <b-col>
                        <p>
                          <small class="bold">{{ $t("descriptionLabel") }}</small>
                          <br />
                          <small>{{ offer.description }}</small>
                        </p>
                      </b-col>
                      <b-col v-if="offer.type !== 'OFFER'" class="border-box">
                        <p>
                          <small class="bold">{{ $t("startDateLabel") }}</small>
                          <br />
                          <small>{{ formatDate(offer.startDate, "DD/MM/YYYY", "YYYY-MM-DDThh:mm:ss") }}</small>
                        </p>
                      </b-col>
                      <b-col v-if="offer.type !== 'OFFER'" class="border-box">
                        <p>
                          <small class="bold">{{ $t("endDateLabel") }}</small>
                          <br />
                          <small>{{ formatDate(offer.endDate, "DD/MM/YYYY", "YYYY-MM-DDThh:mm:ss") }}</small>
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="border-box">
                        <p v-if="offer.reject_reason.length > 0">
                          <small class="bold">{{ $t("rejectReasonLabel") }}</small>

                          <small>{{ offer.reject_reason }}</small>
                        </p>
                      </b-col>
                    </b-row> </b-container>
                </div>
              </div>
              <!-- <img class="personimg" :src="getImagePath() + 'users/user_' + user.person.id + '.png'"
                @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
              <div width="30%">
                <h5 class="h5-small">
                  {{ user.person.first_name ? user.person.first_name + " " + user.person.last_name : user.username }}
                </h5>
                <p v-if="user.person.first_name" class="p-small" v-html="
                  $t('activityDomain', {
                    domain: user.person.activity_domain,
                  })
                "></p>
              </div>
              <div><strong v-if="isUserPremium(user)" class="culoare-11"> {{ $t('userModeLabel_2') }}</strong>
                <strong v-else> {{ $t('userModeLabel_1') }}</strong>
              </div>
              <a @click="switchModifyOrDeleteModalPopup('DELETE', user)">
                <img src="@/assets/images/delete.svg" />
              </a> -->
            </div>

          </div>
          <div class="d-flex justify-content-between align-items-center ">
            <a v-if="isUserAdmin(user) && this.filter.person" class="button-all button-orange"
              @click="transferOffers()">{{
                $t("transferButtonLabel")
              }}</a>
          </div>
        </div>
      </div>
    </div>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <p>
          {{ $t("confirmDeleteOfferMessage") }}
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteOffer()">
            {{ $t("notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="noAction()">
            {{ $t("notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
    <div id="modal_popup_reject" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_reject', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div style="padding: 50px;
      padding-bottom: 0px;">
          <h1>
            {{ $t("confirmRejectOfferTitle") }}
          </h1>
          <p>
            {{ $t("confirmRejectOfferMessage") }}
          </p>
          <p>
            <textarea required v-model="rejectionReason" class="formedituser" />
          </p>
          <div>
            <a href="#" class="noButton" @click="noAction()">
              {{ $t("cancelChangesLabel") }}
            </a>
            <a class="button-all button-red" @click="approveOffer()">{{
              $t("rejectOfferButtonLabel")
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <p v-html="$t('error_' + this.error.description)"></p>
        </div>
        <div v-else>
          <br />
          <p>{{ $t(this.successMessage) }}</p>
        </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
</div>
</template>

<script>
import MenuItems from "../components/company/MenuItems.vue";
import TopBar from "../components/company/TopBar.vue";
import Cookies from "js-cookie";
import httpServiceCustomer from "@/http/http-customer.js";
import httpServiceUser from "@/http/http-user.js";
// import ModalLoading from "../components/fragments/ModalLoading.vue";

import {
  BFormCheckbox,
  BContainer,
  BRow,
  BCol,
} from "bootstrap-vue";
import PersonDetails from "@/components/company/PersonDetails.vue";

export default {
  name: "ManageOffers",

  components: {
    "b-container": BContainer,
    "b-row": BRow,
    "b-col": BCol,
    "b-form-checkbox": BFormCheckbox,
    // ModalLoading,
    TopBar,
    MenuItems,
    PersonDetails
  },
  data() {
    return {
      user: null,
      offerTypes: ["OFFER", "TRAINING", "EVENT"],
      filter: {
        type: "OFFER",
        person: null
      },
      sortBy: ["NEW", "OLD"],
      sortBySelected: "NEW",
      sortField: "valstdate",
      sortDirection: "desc",
      dedicatedOffers: null,
      premium: null,
      error: null,
      perPage: 10000,
      deleteSuccess: false,
      selectedOffer: null,
      selectedOffers: [],
      personForTransfer: null,
      rejectionReason: "",
      successMessage: "",
      usersForManageCompany: null,
      usersForTransfer: [],
      isLoading: false,
      selectedPerson: null,


    };
  },
  methods: {
    editOffer(offer) {
      this.$router.push({
        name: "newOffer",
        params: { offer: offer.id }
      });
    },
    seeUserProfile(person) {
      this.selectedPerson = person;
    },
    customLabel({ first_name, last_name, email }) {
      return first_name ? `${first_name}  ${last_name}` : `${email}`;
    },
    deleteOffer() {
      this.successMessage = "";
      this.error = null;
      this.showModalPopup("modal_popup_confirm", false);
      // this.showModalPopup("modal_popup_loading", true);

      httpServiceCustomer.customerService
        .deleteOfferForCompany(
          this.selectedOffer.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.successMessage = "deleteOfferSuccessMessage";
            this.getDedicatedOffers();
          } else {
            this.error = { description: response.status };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error = { description: error.response.status };
          } else {
            this.error = { description: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    isOfferChecked(entry) {
      for (let index in this.selectedOffers) {
        if (entry.id === this.selectedOffers[index].id) {
          return index;
        }
      }
      return -1;
    },
    offerChecked(entry) {
      let indexOfferSelected = -1;
      for (let index in this.selectedOffers) {
        if (entry.id === this.selectedOffers[index].id) {
          indexOfferSelected = index;
        }
      }
      if (indexOfferSelected === -1) {
        this.selectedOffers.push(entry);
      } else {
        this.selectedOffers.splice(indexOfferSelected, 1);
      }
    },
    transferOffers() {
      if (this.selectedOffers.length === 0) {
        this.error = { description: "OFFER_LIST_EMPTY" };
        this.showModalPopup("modal_popup_info", true);
        return;
      }
      // this.showModalPopup("modal_popup_loading", true);
      let details = [];
      for (let index in this.selectedOffers) {
        details.push({
          id: this.selectedOffers[index].id,
        });
      }
      let offerTransferData = {
        id: 0,
        user_id: this.personForTransfer.user_id,

        offers: this.selectedOffers
      };
      httpServiceCustomer.customerService
        .transferOffers(
          offerTransferData,
          Cookies.get("token"),
        )
        .catch(error => {
          return error.response
        })
        .then(response => {
          if (response.status === 200) {
            this.successMessage = "transferOfferSuccessMessage";
            this.error = null;
            this.getDedicatedOffers();
          } else {
            this.error = { description: response.status };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
      // if (error.response.data) {
      //   this.error = { description: error.response.data };
      // } else if (error.response.status === 409) {
      //   this.error = { description: error.response.status };
      // }
    },
    getDedicatedOffers() {
      this.selectedOffers = [];
      this.dedicatedOffers = null;
      var offersData = "?type=" + this.filter.type;
      offersData += "&manage=Y";
      if (this.isUserMarketing(this.user)) {
        // offersData += "&status=NEW";
        offersData += "&mkt=Y";
      } else if (this.isUserAdmin(this.user)) {
        offersData += "&person=";
        offersData += this.filter.person ? this.filter.person.id : (this.user.person.id + "&admin=Y");
      } else{
        offersData += "&person=";
        offersData += this.user.person.id;
      }
      offersData +=
        "&per_page=" +
        this.perPage +
        "&page=1" +
        "&sort=" +
        this.sortDirection;
      if (this.sortDirection === "desc") {
        offersData += "&desc=" + this.sortField;
      } else {
        offersData += "&asc=" + this.sortField;
      }
      httpServiceCustomer.customerService
        .searchOffers(offersData, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.error = {
            code: error.response.data,
            description: error.response.data,
          };
        })
        .then((response) => {
          if (response.status == 200) {
            this.dedicatedOffers = response.data;
            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.error = {
              code: response.data,
              description: response.data,
            };
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.error = { description: response.description };
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          }
        });
    },
    sortByChanged(event) {
      this.sortBySelected = event.target.value;
      switch (this.sortBySelected) {
        case "NEW":
          this.sortField = "valstdate";
          this.sortDirection = "desc";
          break;
        case "OLD":
          this.sortField = "valstdate";
          this.sortDirection = "asc";
          break;
        default:
          this.sortField = "valstdate";
          this.sortDirection = "desc";
      }
      this.getDedicatedOffers();
    },
    getUsersForManageCompany() {
      this.isLoading = true;
      this.userManageError = null;

      httpServiceUser.userService
        .getUsersForManageCompany(
          this.user.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200) {
            this.usersForManageCompany = response.data;
            this.usersForTransfer = [];
            this.usersForManageCompany.forEach(x => {
              this.usersForTransfer.push({
                user_id: x.id,
                first_name: x.person.first_name,
                last_name: x.person.last_name,
                email: x.username
              });
            });
            this.personForTransfer = this.usersForTransfer[0];
          } else {
            this.userManageError = { description: response.status };
            this.showModalPopup("modal_popup_info", true);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { description: error.response.status };
          } else {
            this.userManageError = { description: "undefined" };
          }
          this.isLoading = false;
          this.showModalPopup("modal_popup_info", true);
        });
    },
    selectPerson(user) {
      this.filter.person = user.person;
      this.selectedOffers = [];
      this.getDedicatedOffers();
    },
    selectFilterType(entry) {
      this.filter.type = entry;
      this.getDedicatedOffers();

    },
    switchModifyOrDeleteModalPopup(actionType, offer) {
      if (actionType === 'DELETE') {

        this.showModalPopup("modal_popup_confirm", true);
      } else if (actionType === 'REJECT') {
        this.showModalPopup("modal_popup_reject", true);
      }
      this.selectedOffer = offer;
    },
    approveOffer(offer) {
      this.successMessage = "";
      this.error = null;
      // this.showModalPopup("modal_popup_loading", true);

      let offerSubmitted = offer;
      if (!offer) {
        offerSubmitted = this.selectedOffer;
        offerSubmitted.status_id = 11; // rejected
        offerSubmitted.reject_reason = this.rejectionReason;
      } else {
        offerSubmitted.status_id = 12; //approved

      }
      httpServiceCustomer.customerService
        .updateOffer(offerSubmitted, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.error = { code: error.response.code };
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.error = null;
            this.getDedicatedOffers();
            this.successMessage = offer ? this.$t("approveDataSuccess") : this.$t("rejectDataSuccess");
            this.showModalPopup("modal_popup_reject", false);
          } else {
            this.error = {
              code: response.data.code,
              description: "Error modifying offer",
            };
            this.showModalPopup("modal_popup_info", true);
          }
          this.showModalPopup("modal_popup_confirm", false);
          // this.showModalPopup("modal_popup_loading", false);
        });
    },
    noAction() {
      this.selectedOffer = null;
      this.showModalPopup("modal_popup_confirm", false);
      this.showModalPopup("modal_popup_reject", false);
    }
  },
  mounted() {
    this.getDedicatedOffers();
    if (this.isUserAdmin(this.user)) {
      this.getUsersForManageCompany();
    }
  },
  computed: {},
  created() {
    this.user = this.getUser();

  },
};
</script>

<style scoped src="@/assets/styles/beneficiary.css" />
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style src="@/assets/styles/multiselect.css" />

<style scoped>
.right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.left {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.left small {
  padding-right: 10px;
}

.left .status_11 {
  color: #FF0000;
}

.left .status_10 {
  color: #7ea800;
}

.left .status_12 {
  color: #FF0000;
}

.left .status_13 {
  color: #3C4645;
}

.content-delivery {
  flex-direction: column;
  margin-bottom: 20px;
}

.content-delivery .personimg {
  width: 64px;
  height: 64px;
  border-radius: 100%;
  margin: 20px;
}

.offer_header {
  width: 100%;
  border-bottom: 1px solid #dcdee3;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.offer_details {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.offer_details .image {
  max-width: 80px;
  max-height: 80px;
  margin: 10px;
  padding: 30px;
}

.offer_details .imageDiv {
  /* height: 128px;
  width: 128px !important;
  margin: 10px; */
  border-radius: 100%;
  border: 1px solid #dcdee3;
  margin: 10px;
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-red {
  border: 1px solid #FF0000;
  border-radius: 100px !important;
}

.multiselect {
  width: 50% !important;
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;

}

.margin-y-10 {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
